import React from "react"

import { BaseProps } from "@humanpredictiveintelligence/myqvt-library"
import {
  UnprocessedRecipientComments,
} from "features/Comments/UnprocessedRecipientComments"
import { Processing_Status as ProcessingStatus, SurveyContentType } from "models/generated"
import config from "config/business"

import {
  useUnprocessedRecipientCommentsQuery,
} from "graphql/queries/generated/UnprocessedRecipientComments"
import {
  useRecipientCommentsWithDraftedAnswerCountQuery,
} from "graphql/queries/generated/RecipientCommentsWithDraftedAnswerCount"
import {
  useRecipientCommentsAwaitingAnswerCountQuery,
} from "graphql/queries/generated/RecipientCommentsAwaitingAnswerCount"
import {
  useRecipientCommentsWithCurrentFiltersCountQuery,
} from "graphql/queries/generated/RecipientCommentsWithCurrentFiltersCount"

export const UnprocessedGlobalRecipientCommentsContainer = (props: UnprocessedRecipientCommentsContainerProps) => {
  const [ pagingInfo, setPagingInfo ] = React.useState({
    currentPage: 1,
    pageSize: config.homepage.unprocessedComments.pageSizes[0],
  })
  const [ filters, setFilters ] = React.useState<ProcessingStatus[]>([
    ProcessingStatus.Awaiting,
    ProcessingStatus.Draft,
  ])

  const {
    data: recipientsCommentsData,
    loading: areCommentsLoading,
    error: loadingErrors,
    refetch: fetchCommentsPage,
  } = useUnprocessedRecipientCommentsQuery({
    variables: {
      limit: pagingInfo.pageSize,
      processingStatuses: filters,
      skip: (pagingInfo.currentPage - 1) * pagingInfo.pageSize,
      surveyContentType: props.surveyContentType,
    },
  })
  const { data: draftedCountData } = useRecipientCommentsWithDraftedAnswerCountQuery({
    variables: {
      surveyContentType: props.surveyContentType,
    },
  })
  const { data: awaitingCountData } = useRecipientCommentsAwaitingAnswerCountQuery({
    variables: {
      surveyContentType: props.surveyContentType,
    },
  })
  const { data: commentsWithFilterCountData } = useRecipientCommentsWithCurrentFiltersCountQuery({
    variables: {
      processingStatuses: filters,
      surveyContentType: props.surveyContentType,
    },
  })

  return (
    <UnprocessedRecipientComments
      className={props.className}
      unprocessedComments={recipientsCommentsData?.global.recipientComments}
      recipientCommentsAwaitingAnswerCount={awaitingCountData?.global.recipientCommentsAwaitingAnswerCount}
      recipientCommentsWithCurrentFiltersCount={
        commentsWithFilterCountData?.global.recipientCommentsWithCurrentFiltersCount
      }
      recipientCommentsWithDraftedAnswerCount={draftedCountData?.global.recipientCommentsWithDraftedAnswerCount}
      areCommentsLoading={areCommentsLoading}
      errors={loadingErrors}
      onFiltersChange={(filters) => setFilters(filters)}
      onCommentsSaved={reloadCurrentPage}
      onPagedNavigationSizeChange={props.onPagedNavigationSizeChange}
      onPaginationChange={(currentPage, pageSize) => setPagingInfo({ currentPage, pageSize })}
      isGlobalComments
    />
  )

  /**
   * Reload the current page
   */
  function reloadCurrentPage() {
    fetchCommentsPage({
      limit: pagingInfo.pageSize,
      processingStatuses: filters,
      skip: (pagingInfo.currentPage - 1) * pagingInfo.pageSize,
    })
  }
}

export interface UnprocessedRecipientCommentsContainerProps extends BaseProps {
  onPagedNavigationSizeChange?: (height: number) => void,
  surveyContentType: SurveyContentType,
}
